import { HTTP } from "./http";

let API_SERVER = "";
if (window.location.href.indexOf("8080") > -1) {
  API_SERVER = "http://www.localhost:8888/back-end-endpoint-password-reset.php";
} else {
  API_SERVER = "/personal-training-BE/back-end-endpoint-password-reset.php";
}

const PasswordReset = {
  /**
   * Ask the backend to send a reset link.
   *
   * Server-side because Firebase accounts are created lazily on first login:
   * a member who has never signed in has no Firebase user, and Firebase then
   * accepts the request and silently sends nothing. The backend creates the
   * missing account first and mails the link through the club's own sender.
   */
  request(clubId, email) {
    return HTTP.post(API_SERVER, {
      action: "requestPasswordReset",
      clubId,
      email,
    });
  },
};

export { PasswordReset };
